import { render } from "./FromAbroadOrderDataPage.vue?vue&type=template&id=78e8ce47"
import script from "./FromAbroadOrderDataPage.vue?vue&type=script&lang=js"
export * from "./FromAbroadOrderDataPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__